import { formatMoney } from "utils";

const FINISH_COPY = {
  "Print only": "Rolled in an archival tube",
  Framed: "Handmade wood frame, ready to hang",
};

const SIZE_BADGES = {
  "30 × 45 cm (12 × 18 in)": "Most popular",
  "40 × 60 cm (16 × 24 in)": "Great for gifting",
};

function parseSize(value) {
  const match = value.match(/^(.+?)\s*\((.+)\)\s*$/);
  if (!match) return { cm: value, inches: "" };
  return { cm: match[1].trim(), inches: match[2].trim() };
}

function getVariants(root) {
  const json = root.querySelector('[id^="all-variant-data-"]');
  if (!json) return [];
  try {
    return JSON.parse(json.textContent);
  } catch {
    return [];
  }
}

function getSelectedFinish(root) {
  const checked = root.querySelector('input[name="Frame"]:checked');
  return checked ? checked.value : "Framed";
}

function getSelectedSize(root) {
  const checked = root.querySelector('input[name="Size"]:checked');
  return checked ? checked.value : "";
}

function findVariant(variants, size, finish) {
  return variants.find((variant) => variant.option1 === size && variant.option2 === finish);
}

function money(price) {
  const format = window.theme?.money_product_price_format || window.theme?.money_format;
  return formatMoney(price, format);
}

function enhanceSizeTiles(root, variants) {
  const finish = getSelectedFinish(root);
  root.querySelectorAll('input[name="Size"]').forEach((input) => {
    const label = root.querySelector(`label[for="${input.id}"]`);
    if (!label || label.dataset.kkhEnhanced === "true") return;

    const { cm, inches } = parseSize(input.value);
    const variant = findVariant(variants, input.value, finish);
    const badge = SIZE_BADGES[input.value] || "";
    const price = variant ? money(variant.price) : "";

    label.dataset.kkhEnhanced = "true";
    label.innerHTML = `
      <span class="kkh-tile__row">
        <span class="kkh-tile__size">${cm}</span>
        ${inches ? `<span class="kkh-tile__inches">${inches}</span>` : ""}
        ${badge ? `<span class="kkh-tile__badge">${badge}</span>` : ""}
      </span>
      ${price ? `<span class="kkh-tile__price">${price}</span>` : ""}
    `;
  });
}

function enhanceFinishTiles(root) {
  root.querySelectorAll('input[name="Frame"]').forEach((input) => {
    const label = root.querySelector(`label[for="${input.id}"]`);
    if (!label || label.dataset.kkhFinishEnhanced === "true") return;

    const desc = FINISH_COPY[input.value] || "";
    label.dataset.kkhFinishEnhanced = "true";
    label.innerHTML = `
      <span class="kkh-tile__main">
        <span class="kkh-tile__size">${input.value}</span>
        ${desc ? `<span class="kkh-tile__desc">${desc}</span>` : ""}
      </span>
    `;
  });
}

function setupFinishGrid(root) {
  const finishFieldset = root.querySelector('input[name="Frame"]')?.closest("fieldset");
  if (finishFieldset) {
    finishFieldset.classList.add("kkh-finish-grid");
    finishFieldset.style.setProperty("--columns", "2");
  }

  const sizeFieldset = root.querySelector('input[name="Size"]')?.closest("fieldset");
  if (sizeFieldset) {
    sizeFieldset.style.setProperty("--columns", "1");
  }
}

function relabelOptions(root) {
  const sizeLegend = root.querySelector('input[name="Size"]')?.closest("fieldset")?.querySelector("legend");
  if (sizeLegend) sizeLegend.textContent = "Select size";

  const finishLegend = root.querySelector('input[name="Frame"]')?.closest("fieldset")?.querySelector("legend");
  if (finishLegend) finishLegend.textContent = "Finish";
}

function updateSelectionSummary(root, variants) {
  const summary = document.getElementById("kkh-price-summary");
  if (!summary) return;

  const size = getSelectedSize(root);
  const finish = getSelectedFinish(root);
  const variant = findVariant(variants, size, finish);
  if (!size || !finish || !variant) {
    summary.textContent = "";
    return;
  }

  const { cm, inches } = parseSize(size);
  const sizeLabel = inches ? `${cm} (${inches})` : cm;
  const finishCopy = finish === "Framed" ? "Ready to hang" : "Free worldwide shipping";

  summary.innerHTML = `
    <span class="kkh-price-summary__price">${money(variant.price)}</span>
    <span aria-hidden="true">·</span>
    <span>${sizeLabel}</span>
    <span aria-hidden="true">·</span>
    <span>${finish}</span>
    <span aria-hidden="true">·</span>
    <span>${finishCopy}</span>
  `;
}

function resetEnhancementFlags(root) {
  root.querySelectorAll("[data-kkh-enhanced],[data-kkh-finish-enhanced]").forEach((node) => {
    delete node.dataset.kkhEnhanced;
    delete node.dataset.kkhFinishEnhanced;
  });
}

function refresh(root) {
  const variants = getVariants(root);
  resetEnhancementFlags(root);
  setupFinishGrid(root);
  relabelOptions(root);
  enhanceSizeTiles(root, variants);
  enhanceFinishTiles(root);
  updateSelectionSummary(root, variants);
}

function init() {
  const root = document.querySelector("variant-radios");
  if (!root) return;

  root.classList.add("kkh-variant-enhanced");

  const run = () => refresh(root);

  window.setTimeout(run, 50);

  root.addEventListener("change", () => {
    window.requestAnimationFrame(run);
  });

  document.addEventListener("variant:changed", run);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
